import { useState } from 'react';
import { QueryClient } from '@tanstack/react-query';
export const useClient = () => {
    const [client] = useState(new QueryClient());
    return client;
};
//# sourceMappingURL=useClient.js.map